import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    // Si pas connecté, redirige vers login
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
